export default "__VITE_ASSET__287fe6cf__"